// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EntityPropertyIdBuf } from '../entity/entity-property-id-buf.js';
import { PropertyFilterType } from '../interface/property-filter-type.js';


/**
 * This represents the view mode filter settings for our object, which
 * could include various kinds of filters, such as contains, greater than,
 * etc. Because of this variation, the filter can either be a text filter
 * or a number filter, which you know from the type
 */
export class ViewModeFilterBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ViewModeFilterBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsViewModeFilterBuf(bb:flatbuffers.ByteBuffer, obj?:ViewModeFilterBuf):ViewModeFilterBuf {
  return (obj || new ViewModeFilterBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsViewModeFilterBuf(bb:flatbuffers.ByteBuffer, obj?:ViewModeFilterBuf):ViewModeFilterBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ViewModeFilterBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

propertyId(obj?:EntityPropertyIdBuf):EntityPropertyIdBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new EntityPropertyIdBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

type():PropertyFilterType {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : PropertyFilterType.Exists;
}

/**
 * This can be a string, number, date, etc. but we serialize to string
 * for ease of use. Some filters have no value as well
 */
value():string|null
value(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
value(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

static startViewModeFilterBuf(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addPropertyId(builder:flatbuffers.Builder, propertyIdOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, propertyIdOffset, 0);
}

static addType(builder:flatbuffers.Builder, type:PropertyFilterType) {
  builder.addFieldInt8(1, type, PropertyFilterType.Exists);
}

static addValue(builder:flatbuffers.Builder, valueOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, valueOffset, 0);
}

static endViewModeFilterBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createViewModeFilterBuf(builder:flatbuffers.Builder, propertyIdOffset:flatbuffers.Offset, type:PropertyFilterType, valueOffset:flatbuffers.Offset):flatbuffers.Offset {
  ViewModeFilterBuf.startViewModeFilterBuf(builder);
  ViewModeFilterBuf.addPropertyId(builder, propertyIdOffset);
  ViewModeFilterBuf.addType(builder, type);
  ViewModeFilterBuf.addValue(builder, valueOffset);
  return ViewModeFilterBuf.endViewModeFilterBuf(builder);
}
}
